<template>
	<div class="footer">
		<div class="footer_mid">
			<div class="inner">
				<div class="footer_nav">
					<p>联系电话：010-59799951</p>
					<p>地址：北京市海淀区北四环西路9号银谷大厦2108室</p>
				<!-- 	<p>精英加盟 hr@eframesoft.com </p> -->
					<p>邮箱：business@eframesoft.com</p>
				<!-- 	<p>技术支持 support@eframesoft.com</p> -->
					
		<!-- 			<div style="display: flex;">
						<div class="footer_navs">
							<el-popover
							  placement="top"
							  width="200"
							  trigger="hover">
							  <img src="../assets/shipin.jpg" alt="" style="width: 200px;">
							  
							   <div class="weibo" slot="reference">
								   <img src="../assets/新浪微博.png" alt="">
							   </div>
							</el-popover>
						</div>
						<div class="footer_navs">
							<el-popover
							  placement="top"
							  width="200"
							  trigger="hover">
							  <img src="../assets/shipin.jpg" alt="" style="width: 200px;">
							  
							   <div class="weibo" slot="reference">
								   <img src="../assets/微信.png" alt="">
							   </div>
							</el-popover>
						</div>
						<div class="footer_navs">
							<el-popover
							  placement="top"
							  width="200"
							  trigger="hover">
							  <img src="../assets/shipin.jpg" alt="" style="width: 200px;">
							  
							   <div class="weibo" slot="reference">
								   <img src="../assets/QQ.png" alt="">
							   </div>
							</el-popover>
						</div>
					</div> -->
					
				</div>
				<div class="footer_right">
					<div class="footer_rights">
						<div class="footer_rightss">
							<img src="../assets/weibo.png" alt="">
						<!-- 	<p>领驭框架软件</p> -->
						</div>
						<div class="footer_rightss">
							<img src="../assets/weixin.png" alt="">
							<!-- <p>领驭融合</p> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer_bot">
			<p>
				<a href="https://beian.miit.gov.cn/" target="_blank">版权所有© 领驭框架（北京）软件有限公司 京ICP备2021007496号</a>
			</p>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				
			}
		},
		methods:{
			
		},
	}
</script>

<style lang="scss" scoped>
	.footer{
		// height: 313px;
		// margin-top: 30px;
		.footer_bot{
			height: 52px;
			overflow: hidden;
			text-align: center;
			background-color: #454545;
			p{
				height: 28px;
				line-height: 28px;
				font-size: 14px;
				color: #89898b!important;
				a{
					color: #fff;
					text-decoration: none;
				}
			}
		}
		.footer_right{
			display: flex;
		    margin-left: auto;
			.footer_rights{
				display: flex;
				height: 100%;
				justify-content: flex-end;
				align-items: flex-end;
				.footer_rightss{
					margin-left: 30px;
					img{
						width: 130px;
						height: 130px;
					}
					p{
						font-size: 14px;
						color: #fff;
						width: 130px;
						text-align: center;
					}
				}
			}
		}
		.weibo{
			width: 30px;
			height: 30px;
			border-radius: 50%;
			border: 1px solid #7a7a7a;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			img{
				width: 16px;
				height: 16px;
			}
		}
		background-color: #454545;
		position: relative;
		z-index: 2;
		.footer_mid{
			padding: 38px 0;
			border-bottom: 1px solid #3b3d4c;
			border-top: 1px solid #3b3d4c;
			.inner{
				width: 1200px;
				margin: 0 auto;
				overflow: hidden;
				display: flex;
				.footer_nav{
					height: 100%;
					p{
						color: #fff;
					}
					.footer_navs{
						display: flex;
						margin-top: 20px;
						span{
							margin-right: 20px;
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue